import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Package, Calendar, Utensils } from 'lucide-react';
export const WhatsAppSection: React.FC = () => {
  const [hoveredOption, setHoveredOption] = useState<string | null>(null);
  const whatsappOptions = [{
    id: 'delivery',
    icon: <Package size={36} data-id="element-180" />,
    title: 'Ordenar para entrega a domicilio',
    message: 'Hola Perla Negra, me gustaría hacer un pedido para entrega a domicilio...'
  }, {
    id: 'events',
    icon: <Calendar size={36} data-id="element-181" />,
    title: 'Solicitar información sobre eventos',
    message: 'Hola Perla Negra, me gustaría solicitar información sobre eventos...'
  }, {
    id: 'reservation',
    icon: <Utensils size={36} data-id="element-182" />,
    title: 'Reservar una mesa',
    message: 'Hola Perla Negra, me gustaría reservar una mesa para...'
  }];
  const handleWhatsAppClick = (message: string) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/50256284598?text=${encodedMessage}`, '_blank');
  };
  return <section className="py-16 px-4 bg-wood-texture bg-cover bg-center relative" data-id="element-183">
      <div className="absolute inset-0 bg-pirate-black opacity-80" data-id="element-184"></div>
      <div className="container mx-auto relative z-10" data-id="element-185">
        <h2 className="font-pirata text-3xl md:text-4xl text-center mb-10" data-id="element-186">
          Contacta a nuestra tripulación
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-187">
          {whatsappOptions.map(option => <motion.div key={option.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} whileHover={{
          scale: 1.03
        }} onMouseEnter={() => setHoveredOption(option.id)} onMouseLeave={() => setHoveredOption(null)} onClick={() => handleWhatsAppClick(option.message)} className="bg-pirate-black bg-opacity-70 border-2 border-pirate-red rounded-lg p-6 flex flex-col items-center text-center cursor-pointer hover:shadow-lg transition-all" data-id="element-188">
              <div className={`text-pirate-red mb-4 transition-transform duration-300 ${hoveredOption === option.id ? 'scale-110' : ''}`} data-id="element-189">
                {option.icon}
              </div>
              <h3 className="font-pirata text-xl mb-3" data-id="element-190">{option.title}</h3>
              <p className="text-sm text-gray-300" data-id="element-191">Click para abrir WhatsApp</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};